<script setup lang="ts">
// Plan 2026-10-04 Task 3: BGA top strip, moved out of BgaJhSignalTab.vue.
// Shrinks the wrapper to its cards; the shell renders this above signalTab.
import SparklineBar from '../SparklineBar.vue'
import type { SignalTabCtx } from '../nav/fundPages'

defineProps<{ ctx: SignalTabCtx }>()
</script>

<template>
  <SparklineBar
    :fund-return-pct="ctx.activeFundReturnPct"
    :nas-return-pct="ctx.nasReturnPct"
    :vix="ctx.intSignal?.vix ?? null"
    :gbpusd-return-pct="ctx.gbpusdReturn" />
</template>
